export default {
  dialog: {
    add: {
      title: 'افزودن کاربر جدید',
      description: 'جزئیات کاربر جدید را در اینجا وارد کنید. پس از اتمام روی ذخیره کلیک کنید.'
    },
    update: {
      title: 'بروزرسانی کاربر',
      description: 'جزئیات این کاربر را بروزرسانی کنید. پس از اتمام روی ذخیره کلیک کنید.'
    },
    invite: {
      title: 'دعوت کاربر',
      description: 'جزئیات دعوت کاربر را در اینجا وارد کنید. پس از اتمام روی ارسال کلیک کنید.'
    }
  },
  fields: {
    name: 'نام',
    email: 'ایمیل',
    role: 'نقش',
    branch: 'شعبه',
    password: 'رمز عبور',
    selectRole: 'انتخاب نقش',
    selectBranch: 'انتخاب شعبه',
    qboUser: 'کاربر کوییک‌بوکس',
    selectQboUser: 'انتخاب کاربر کوییک‌بوکس (اختیاری)',
    noQboUser: 'بدون کاربر کوییک‌بوکس',
    loadingQboUsers: 'در حال بارگذاری کاربران کوییک‌بوکس...',
    status: 'وضعیت حساب',
    selectStatus: 'انتخاب وضعیت حساب'
  },
  buttons: {
    save: 'ذخیره تغییرات',
    sendInvitation: 'ارسال دعوت‌نامه'
  },
  roles: {
    admin: 'مدیر',
    noc: 'ناک',
    installer: 'نصاب',
    financeAdmin: 'مدیر مالی',
    sales: 'فروش',
    creditChecker: 'بررسی اعتبار',
    cashier: 'صندوقدار'
  },
  columns: {
    cartId: 'شناسه کارت',
    name: 'نام',
    email: 'ایمیل',
    role: 'نقش',
    branch: 'شعبه',
    center: 'مرکز',
    qboUser: 'کاربر کوییک‌بوکس',
    noQboUser: 'تخصیص نشده',
    actions: 'عملیات',
    unassigned: 'تخصیص نشده',
    status: 'وضعیت'
  },
  status: {
    enabled: 'فعال',
    disabled: 'غیرفعال'
  },
  title: 'کاربران',
  actions: {
    invite: 'دعوت',
    copyId: 'کپی شناسه',
    delete: 'حذف',
    update: 'بروزرسانی',
    reInvite: 'ارسال مجدد دعوت',
    enable: 'فعال کردن',
    disable: 'غیرفعال کردن'
  },
  notifications: {
    idCopied: {
      title: 'شناسه کپی شد',
      description: 'شناسه کاربر به کلیپ بورد کپی شد'
    },
    deleted: {
      title: 'کاربر حذف شد',
      description: 'کاربر با موفقیت حذف شد'
    },
    reInvited: {
      title: 'دعوت مجدد ارسال شد',
      description: 'ایمیل دعوت با موفقیت مجدداً ارسال شد'
    },
    enabled: {
      title: 'کاربر فعال شد',
      description: 'حساب کاربری با موفقیت فعال شد'
    },
    disabled: {
      title: 'کاربر غیرفعال شد',
      description: 'حساب کاربری با موفقیت غیرفعال شد'
    },
    error: {
      title: 'خطا',
      description: 'خطایی در انجام عملیات رخ داد'
    }
  }
} 